import { INSURANCE_ID_FIELD } from './columnConfig';

export const tableConfig = {
  index: INSURANCE_ID_FIELD,
  renderVerticalBuffer: 1500,
};
